var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showExclusiveFeaturedEvents
      ? _c(
          "div",
          { staticClass: "exclusive-featured-events-wrapper" },
          [
            _c("div", { staticClass: "exclusive-featured-events-heading" }, [
              _c(
                "span",
                { staticClass: "exclusive-featured-events-heading__title" },
                [_vm._v(_vm._s(_vm.$config.exclusiveTitleCopy))]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "exclusive-featured-events-heading__redeem" },
                [_vm._v(_vm._s(_vm.$config.exclusiveRedeemCopy))]
              ),
              _vm._v(" "),
              _vm.logoDesktop
                ? _c("img", {
                    staticClass: "exclusive-featured-events-heading__logo",
                    style: _vm.logoDesktop.overrideStyles,
                    attrs: {
                      alt: _vm.logoDesktop.alt,
                      src: _vm.logoDesktop.url
                    }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "exclusive-featured-events-list-wrapper" },
              [
                _vm.$config.hasExclusiveFeaturedEventsView
                  ? _c(
                      "ul",
                      { staticClass: "exclusive-featured-events-list" },
                      _vm._l(_vm.sortedExclusiveFeaturedEvents, function(
                        event,
                        index
                      ) {
                        return _c(
                          "li",
                          {
                            key: event.id,
                            staticClass: "exclusive-featured-event-card"
                          },
                          [
                            _c("ExclusiveFeaturedEventTile", {
                              attrs: { event: event, index: index }
                            })
                          ],
                          1
                        )
                      })
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("router-link", { attrs: { to: { name: "exclusive" } } }, [
              _vm.showExclusiveEventsLink
                ? _c("h4", { staticClass: "exclusive-featured-link" }, [
                    _vm._v(_vm._s(_vm.$config.exclusiveLinkCopy))
                  ])
                : _vm._e()
            ])
          ],
          1
        )
      : _c("div", { staticClass: "featured-events-wrapper" }, [
          _c(
            "ul",
            { staticClass: "featured-events-list" },
            _vm._l(_vm.featuredEvents, function(event, index) {
              return _c(
                "li",
                { key: event.id, staticClass: "featured-event-card" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: _vm.makeEventRoute(event) } },
                    [
                      _vm.isWindowSmall || _vm.isWindowMedium
                        ? _c("div", {
                            staticClass:
                              "featured-event-image featured-event-image--mobile",
                            style: {
                              backgroundImage:
                                "url(" + event.imageUrlRectangle + ")"
                            },
                            attrs: {
                              "data-e2e": "home.featured-event-listing-image"
                            }
                          })
                        : _c("div", {
                            staticClass:
                              "featured-event-image featured-event-image--desktop",
                            style: {
                              backgroundImage:
                                "url(" +
                                (index === 0
                                  ? event.imageUrlRectangle
                                  : event.imageUrlSquare ||
                                    event.imageUrlRectangle) +
                                ")"
                            },
                            attrs: {
                              "data-e2e": "home.featured-event-listing-image"
                            }
                          }),
                      _vm._v(" "),
                      _c("div", { staticClass: "featured-event-info" }, [
                        _c(
                          "div",
                          { staticClass: "featured-event-info__date-time" },
                          [_c("span", [_vm._v(_vm._s(event.name))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "featured-event-info__venue-price" },
                          [
                            event.isDateTbd
                              ? _c("span", [_vm._v(_vm._s(_vm.$t("date-tbd")))])
                              : event.isTimeTbd
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("date")(
                                        event.localDate,
                                        "ddd, MMM D"
                                      )
                                    ) +
                                      ", " +
                                      _vm._s(_vm.$t("time-tbd"))
                                  )
                                ])
                              : event.localDateLabel
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(event.localDateLabel) +
                                      " at " +
                                      _vm._s(
                                        _vm._f("date")(event.localDate, "h:mma")
                                      )
                                  )
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("date")(
                                        event.localDate,
                                        "ddd, MMM D"
                                      )
                                    ) +
                                      " at " +
                                      _vm._s(
                                        _vm._f("date")(event.localDate, "h:mma")
                                      )
                                  )
                                ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "featured-event-info__venue-name"
                                  },
                                  [_vm._v(_vm._s(event.venueName) + " ")]
                                ),
                                _vm._v(" "),
                                !_vm.$config.isIntegrated
                                  ? [
                                      _vm.isLoyaltyPricing &&
                                      event.pointsPriceMin
                                        ? _c("span", [
                                            _vm._v(
                                              "from " +
                                                _vm._s(
                                                  _vm.formatPoints(
                                                    event.pointsPriceMin,
                                                    event.pointsCurrency
                                                  )
                                                )
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "from " +
                                                _vm._s(
                                                  _vm._f("numeral")(
                                                    event.moneyPriceMin,
                                                    "$0,0"
                                                  )
                                                )
                                            )
                                          ])
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            })
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }